import React, { type SelectHTMLAttributes } from 'react'
import { DropdownInput } from '@mobi/component-library/Selection&Input/DropdownInput'
import { Nationality } from '@mobi/account/Common/Address/utils'

type CountrySelectFieldProps = {
  value: Nationality
  onChange: (value: Nationality) => void
  isDisabled?: boolean
} & Omit<SelectHTMLAttributes<HTMLSelectElement>, 'onChange' | 'disabled'>

export const CountrySelectField = ({
  value,
  onChange,
  isDisabled = false,
}: CountrySelectFieldProps) => (
  <DropdownInput
    label='Country'
    name='Country'
    required
    value={value}
    onChange={e => onChange(e.target.value as Nationality)}
    isDisabled={isDisabled}
  >
    {Object.values(Nationality).map(nationality => (
      <option key={nationality} value={nationality}>
        {nationality}
      </option>
    ))}
  </DropdownInput>
)
